import { render, staticRenderFns } from "./entry_history_table.vue?vue&type=template&id=23fb82bc"
import script from "./entry_history_table.vue?vue&type=script&lang=ts"
export * from "./entry_history_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports